import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  Grid,
  Loading,
  TextField,
} from "../../../../components";
import { InputErros, PermisoesHelper } from "../../../../helpers";
import { GrupoProdutosService, notification } from "../../../../services";
import grupoProdutosValidator from "../../../grupoProdutos/addGrupoProdutos/middlewares/grupoProdutos.validator";
import { responseErros } from "../../../../utils";

const CadastroGrupoProdutoDialog = ({
  open,
  handleGrupoCriado,
  handleCloseDialog,
}) => {
  const permissoesHelper = new PermisoesHelper();
  const [loading, setLoading] = useState(false);
  const [grupoProdutos, setGrupoProdutos] = useState({
    ativado: true,
  });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const grupoProdutosService = new GrupoProdutosService();

  useEffect(() => {
    if (open && !permissoesHelper.temPermisao("grupo-produtos-cadastrar")) {
      handleCloseDialog();
    }
  }, [open]);

  const handleInputChange = (event) => {
    setGrupoProdutos((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    grupoProdutosValidator
      .validate(grupoProdutos, { abortEarly: false })
      .then(async () => {
        const response = await grupoProdutosService.cadastrar(grupoProdutos);
        setLoading(false);
        if (!response.isAxiosError) {
          notification.cadastroSucesso();
          handleGrupoCriado(response.data);
        } else {
          handleCloseDialog();
          responseErros(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setGrupoProdutos(null);
    handleCloseDialog();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      disableEnforceFocus
      disableAutoFocus
      fullWidth
      maxWidth="sm"
      style={{ zIndex: 1400 }}
    >
      <Card className="p-3">
        <CardHeader title="Cadastrar Grupo de Produtos" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={grupoProdutos?.descricao ? grupoProdutos.descricao : ""}
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <DialogActions className="m-2">
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
            onClick={handleSubmit}
          >
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            Cancelar
          </Button>
        </DialogActions>
      </Card>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default CadastroGrupoProdutoDialog;
